export function isWechatUserAgent(userAgent: string | null | undefined) {
  if (!userAgent) {
    return false;
  }

  return /micromessenger/i.test(userAgent);
}

export function isWeChatBrowser() {
  if (typeof navigator === "undefined") {
    return false;
  }

  return isWechatUserAgent(navigator.userAgent);
}
